module.exports = __webpack_public_path__ + "img/end-alert.f7c437d4.png";